export { default as ReceivingList } from './ReceivingList';
export { default as ReceivingEdit } from './ReceivingEdit';
export { default as ReceivingDetail } from './ReceivingDetail';



// WEBPACK FOOTER //
// ./src/modules/receiving/pages/index.js